<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Stock Transfer</v-toolbar-title>
		</v-toolbar>

		<v-form class="form-element hasToolbar hasBigFooter grey-back" id="form">

			<v-alert style="height:42px" :value="true" color="warning pt-0 pb-0 pr-0" transition="slide-y-transition" v-if="transactionCount>=1">
              <v-layout row wrap style="align-items:center">
                <v-flex xs8 sm8 md8><v-icon class="font20 whitecolor mr-2">error_outline</v-icon> Set Auto Data Backup</v-flex>
                <v-flex xs4 sm4 md4 right-align>
                  <v-btn style="color:#fff" capitalize flat small @click="fn_gotoSetupDrive">Setup Now</v-btn>
                </v-flex>
              </v-layout>
            </v-alert>

			<div>

				<v-list full-width nopadding>
				  	<v-list-tile>
			          	<v-list-tile-content @click="fn_openDialogNumberSeries">
							<v-list-tile-title class="merged_tnumber">{{Form.transactionData.mergeTransactionNumber}}</v-list-tile-title>
						</v-list-tile-content>

			            <span v-if="Form.transactionData.transactionDate">{{Form.transactionData.transactionDate | moment("DD-MMM-YYYY")}}</span>	
            			<span v-else>DD-MMM-YYYY</span>

			            <v-list-tile-action class="action-small">
            				<v-btn flat icon color="primary" @click.native="fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePicker')" class="no-left-margin">

            					<v-icon>date_range</v-icon>	
            				</v-btn>
			            </v-list-tile-action>
				    </v-list-tile>
				</v-list>

				<v-layout margin-top-ten row wrap white-background padding-top-bottom-ten>

                    <v-flex xs12 sm12 md12 form-item @click="fn_openGodowns('android', 'Godowns', 'ref_fieldFromGodown', Form.fromGodownId, Form.fromGodownName, 'fromgodown')" v-if="$root.TransactionSettings.enableGodown">
		               <v-text-field  
			               	readonly
			               	v-model="Form.fromGodownName" 
			               	label="From Godown"
							:onUpdate="fn_updateFromGodown" 
			               	ref="ref_fieldFromGodown"
			               	placeholder=" " 
			               	append-icon="arrow_drop_down"
                            v-validate="'required'" 
                            data-vv-name="from_godown" 
                            data-vv-as="from godown" 
                            :error-messages="errors.collect('from_godown')"
		               		required>
		               </v-text-field>
		            </v-flex>

                    <v-flex xs12 sm12 md12 form-item @click="fn_openGodowns('android', 'Godowns', 'ref_fieldToGodown', Form.toGodownId, Form.toGodownName, 'togodown')" v-if="$root.TransactionSettings.enableGodown">
		               <v-text-field  
			               	readonly
			               	v-model="Form.toGodownName" 
			               	label="To Godown"
							:onUpdate="fn_updateToGodown" 
			               	ref="ref_fieldToGodown"
			               	placeholder=" " 
			               	append-icon="arrow_drop_down"
                            v-validate="'required'" 
                            data-vv-name="to_godown" 
                            data-vv-as="to godown" 
                            :error-messages="errors.collect('to_godown')"
		               		required>
		               </v-text-field>
		            </v-flex>

                    <!-- <v-flex xs12 sm12 md12 align-msg-right form-item @click="fn_openProductList('android', 'ProductList', 'ref_fieldProductName');">

                        <v-text-field  
                            readonly
                            v-model="Form.productName" 
                            :hide-details="Form.summaryArray.length ? true : false"
                            label="Item" 
                            placeholder=" " 
                            append-icon="arrow_drop_down"
                            :onUpdate="fn_updateProduct"
                            ref="ref_fieldProductName"
                            v-validate="'required'" 
                            data-vv-name="item" 
                            :error-messages="errors.collect('item')"
                            required>
                        </v-text-field>

                        <div custom-message>
                            <span v-for="(item, index) in Form.summaryArray" v-if="Form.summaryArray.length">
                                {{item.unitName}}: <span :class="[item.qty < 0 ? 'redcolor' : 'greencolor']">{{item.roundOffQty}}</span>
                            </span>
                        </div>
                    </v-flex> -->

                    <!-- <v-flex xs12 sm12 md12>
                        <v-text-field 
                            v-model="Form.qty"
                            label="Qty" 
                            placeholder=" "
                            type="number">
                        </v-text-field>
                    </v-flex> -->

                    <!-- <v-flex xs12 sm12 md12 v-if="Form.productData">
                        <v-text-field 
                            :value="Form.Form.productData.unitName"
                            label="Unit" 
                            placeholder=" "
                            type="number">
                        </v-text-field>
                    </v-flex> -->

							
				</v-layout>

                <v-list two-line class="mt-2" nopadding>
                    <v-subheader class="pr-0">Add Item <v-spacer></v-spacer> <v-btn small color="primary" outline round-borders flat @click="fn_addProduct"><v-icon font20 color="primary" class="mr-2">add</v-icon> Add</v-btn></v-subheader>
                    <template v-for="(item, index) in Form.transactionProducts">  
                        <v-divider></v-divider>                
                        <v-list-tile :key="index">
                            <v-list-tile-content @click="fn_editItem(item, index)">
                                <v-list-tile-title>{{ item.productName }}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ item.qty }} {{ item.unitName }} <template v-if="item.averageRate">x {{ $root.numberToLocale(item.averageRate) }}</template></v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action @click="Form.transactionProducts.splice(index, 1)">
                                <!-- <v-icon font20>delete</v-icon> -->
								<v-icon class="redcolor">remove_circle_outline</v-icon>
								<template v-if="item.averageRate">&#8377; {{ $root.numberToLocale(item.averageRate * item.qty) }}</template>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-divider v-if="index != Form.transactionProducts.length - 1"></v-divider>

						<div class="grey-back full-width batch_display_container" v-if="item.batches && item.batches.length">

							<v-expansion-panel nomargin>

								<v-expansion-panel-content>

									<div slot="header" light-opacity-color font16 class="pt-0 pb-0">{{ item.selectedBatchType == 2 ? 'Series#' : 'Batches#' }}</div>
									<v-card flat v-for="(batch, batchIndex) in item.batches" :key="batchIndex">

										<v-card-text class="pb-2 pt-2">
											<v-layout class="batch_layout" row wrap>
												<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
													<div light-opacity-color>Batch No.</div>
													<div>{{ batch.batchNumber }}</div>
												</v-flex>
												<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
													<div light-opacity-color>Size</div>
													<div>{{ batch.batchSize }}</div>
												</v-flex>
												<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
													<div light-opacity-color>MRP</div>
													<div>{{ batch.batchMRP }}</div>
												</v-flex>
												<v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
													<div light-opacity-color>Mfg. Date</div>
													<div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
												</v-flex>
												<v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
													<div light-opacity-color>Exp. Date</div>
													<div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
												</v-flex>
												<!-- <v-flex xs4 sm4 md4 mb-2>
													<div light-opacity-color>Opening</div>
													<div>{{ batch.opening ? batch.opening : 0  }}</div>
												</v-flex> -->
												<v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
													<div light-opacity-color>Purchase Rate</div>
													<div>{{ batch.purchaseRate }}</div>
												</v-flex>
												<v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
													<div light-opacity-color>Serial Number</div>
													<div>{{ batch.field1 }}</div>
												</v-flex>
												<v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
													<div light-opacity-color>IMEI Number</div>
													<div>{{ batch.field2 }}</div>
												</v-flex>
												<v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
													<div light-opacity-color>Part Number</div>
													<div>{{ batch.field3 }}</div>
												</v-flex>
												<v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
													<div light-opacity-color>Model Number</div>
													<div>{{ batch.field4 }}</div>
												</v-flex>
												<v-flex xs4 sm4 md4 mb-2 v-if="item.selectedBatchType == 1 && (item.batches.length > 1 || item.batches.length == 1 && batch.productQty != item.qty)">
													<div light-opacity-color>Quantity</div>
													<div>{{ batch.productQty }}</div>
												</v-flex>
												<v-flex xs12 sm12 md12 redcolor pb-2 v-if="batch.expDate && fn_checkDate(batch)">
													<v-icon class="mr-1 font16 redcolor">info_outline</v-icon> Expired {{ fn_getDate(batch) }}
												</v-flex>
											</v-layout>
										</v-card-text>
										<v-divider v-if="item.batches.length - 1 != batchIndex"></v-divider>
									</v-card>
								</v-expansion-panel-content>

							</v-expansion-panel>

						</div>

						<!-- <v-divider v-if="group.items.length-1 != index && (!item.batches || !item.batches.length)"></v-divider> -->
                    </template>
  
                </v-list>

				<!-- <v-list two-line class="mt-2 mb-2" nopadding v-if="Form.transactionProducts && Form.transactionProducts.length">
                    <v-subheader class="pr-0">Additional Charges <v-spacer></v-spacer> <v-btn color="primary" small round-borders outline @click="fn_openAddOns(3, true)"><v-icon class="primary-color font20 mr-2">add</v-icon> Add</v-btn></v-subheader>
                    <template v-for="(item, index) in Form.transactionAddOns">  
                        <v-divider></v-divider>                
                        <v-list-tile :key="index">
							<v-list-tile-action style="min-width:40px">
								<v-btn icon @click="fn_removeAddOns(item)"><v-icon>close</v-icon></v-btn>
							</v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="max-width: 100px;">
                                <v-text-field 
									class="right-align-textbox"
									v-model.number="item.value" 
									@input="item.percentage = null"  
									type="number" label="" 
									:prefix="item.nature ? '-' : ''"
									v-validate="'min_value:0|decimal:2'" 
									:data-vv-name="'value'+index" 
									:data-vv-as="item.name"
									:error-messages="errors.collect('value'+index)">
								</v-text-field>
                            </v-list-tile-action>
                        </v-list-tile>
                    </template>  
                </v-list> -->

				<v-layout wrap margin-top-ten white-background>
					<v-list full-width nopadding>
					  	<v-list-tile>

					  		<v-list-tile-action v-if="Form.transactionData.notes">
				            	<v-btn icon @click="Form.transactionData.notes = ''">
						  			<v-icon>close</v-icon>
						  		</v-btn>
				            </v-list-tile-action>

				          	<v-list-tile-content full-width @click="fn_addNote">
				              <v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
							  <v-icon style="position:absolute;right:16px">keyboard_arrow_right</v-icon>
				            </v-list-tile-content>
							
					    </v-list-tile>
					</v-list>

					<v-card full-width flat class="note-card" v-if="Form.transactionData.notes">
						<v-divider></v-divider>
					  	<v-card-text font16 v-html="Form.transactionData.notes" white-space-pre-line></v-card-text>
					</v-card>
				</v-layout>

				
			</div>	

		</v-form>

	    <div white-background full-width nopadding style="position:fixed;bottom:0;">
			<v-layout row wrap>
				<template v-if="Form.transactionProducts && Form.transactionProducts.length">
					<v-flex xs6 sm6 md6 pl-3 pt-1 pb-1>Total</v-flex>
					<v-flex xs6 sm6 md6 pr-3 pt-1 pb-1 right-align>&#8377; {{ $root.numberToLocale(totalAmount) }}</v-flex>
				</template>
				<v-flex xs12 sm12 md12 height48>
					<v-btn color="primary" full-height nomargin block no-round-borders noshadow :disabled="disabledBtn" @click="fn_checkValidations">Save</v-btn>
				</v-flex>
			</v-layout>
		</div>


	    <dialog-note ref="ref_dialogNote"></dialog-note>
		<dialog-date-picker ref="ref_dialogDatePicker" :updateDate="fn_updateDate"></dialog-date-picker>

		<dialog-drive-alert ref="ref_dialogDriveAlert" :gotoSetupDrive="fn_setupDrive" :skipAlert="fn_closeDialog" :transactionCount="transactionCount"></dialog-drive-alert>
        <dialog-product ref="ref_dialogProduct"></dialog-product>
		<dialog-select-batch ref="ref_dialogSelectBatch" :appendBatches="fn_appendBatches" :pid="Form.productData.productId" :productData="Form.productData" :openDatePicker="fn_openDatePicker" formType="outward" v-if="Form.productData"></dialog-select-batch>
		<dialog-datepicker-batch ref="ref_dialogDatePickerBatch" :selected="selectedDate" :updateDate="fn_updateBatchDate"></dialog-datepicker-batch>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations"></dialog-discard>
		<dialog-number-series ref="ref_dialogNumberSeries" :checkTransactionNumber="fn_checkTransactionNumber"></dialog-number-series>
		<dialog-addons ref="ref_dialogAddOns" :openAddOnsList="fn_openAddOnsList" :addOnsProp="Form.addOnsProp" :saveAddOns="fn_saveAddOns" type="sale"></dialog-addons>

		<dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="confirmationAction" :okBtnText="confirmationHeader == 'Add batches' ? 'Okay' : 'Yes'" :cancelBtnText="confirmationHeader == 'Add batches' ? 'Cancel' : 'No'" :params="confirmationActionParam"></dialog-confirmation>
		<!-- <dialog-select-batch ref="ref_dialogSelectBatch" :appendBatches="fn_appendBatches" :pid="Form.productData.productId" :productData="Form.productData.items[0]" :openDatePicker="fn_openDatePicker" formType="outward" v-if="Form.productData.items && Form.productData.items.length"></dialog-select-batch> -->

		<v-snackbar v-model="transactionNumberSnackbar" multi-line :timeout="0">
	    	Generate new transaction number?
	    	<v-btn flat icon @click="fn_getNumberSeries" color="primary">okay</v-btn>
	    	<v-btn flat icon @click="transactionNumberSnackbar=false">close</v-btn>
	    </v-snackbar>

	</div>
</template>

<script>
const dialogjs =  require('../../../masters/forms/dialog').dialogjs;
const transactionData = require('../../datamodel').data.transactionData;
import dialogNote from '../dialogs/dialog_note'
import dialogDatePicker from './dialogs/dialog_datepicker'

import dialogDriveAlert from '../../../dialogs/dialog_drive_alert'
import dialogProduct from './dialogs/dialog_product'
import dialogDiscard from '../../../dialogs/dialog_discard'
import dialogNumberSeries from '../dialogs/dialog_number_series_manual'

import dialogSelectBatch from '../dialogs/dialog_select_batch'
import dialogDatePickerBatch from '../../../dialogs/dialog_datepicker_batch'

import dialogAddOns from '../../../dialogs/dialog_addons'

import dialogConfirmation from '../../../dialogs/dialog_confirmation'

import {draftMixin} from '../../../draft_mixin'
import {transactionMixin} from '../../transaction_mixin'

const menuItem = require('../../../../config.js').configs.menuItem;

const productGroupTypeId = require('../../../../config.js').configs.productGroupTypeId;

// import dialogSelectBatch from '../dialogs/dialog_select_batch'
// import dialogDatepickerBatch from '../../../dialogs/dialog_datepicker_batch'

	export default{
		props:['settings'],
		mixins: [draftMixin, transactionMixin],
		// mixins: [transactionMixin],
		data(){
			return{

				Form:{
					"transactionData":JSON.parse(JSON.stringify(transactionData)),
                    "fromGodownId":null,
                    "fromGodownName":null,
                    "toGodownId":null,
                    "toGodownName":null,
                    "productId":null,
                    "productName":null,
                    "qty":null,
                    "summaryArray":[],
                    "transactionProducts":[],
                    "productData":null,
					"averageRate":null,
					"selectedBatchType":null,
					"batches":[],
					"isNew":true,
					"selectedItemIndex":null,
					"transactionAddOns":[],
					"addOnsProp":{},
					"numberSeriesData":null,
					"addOnsDataModel": {"transactionTypeAddOnsId":null, "addOnsId":null, "name":null, "percentage":null, "value":null, "mode":null, "nature":null, "appliedOn":0, "adjustInTotal":true, "orderNumber":null, "addOnsType":null, "type":null},
				},
				// summaryArray:null,
				loading:true,
				tagId:null,
				draftStorageId:null,
				dialogStorageId:null,
				backButtonPress: false,
				// unwatch:false,
				disabledBtn:false,
				transactionNumberSnackbar:false,
				hasOnlySeries:true,
				hasSeries:false,
				seriesFields:[],
				// type:"plus",
				// hasOnlySeries:true,
				// hasSeries:false,
				selectedDate:null,
				// dateType:null,
			}
		},
		components:{
			'dialog-note':dialogNote,
			'dialog-date-picker':dialogDatePicker,
			'dialog-drive-alert':dialogDriveAlert,
            'dialog-product':dialogProduct,
			// 'dialog-select-batch':dialogSelectBatch,
			// 'dialog-datepicker-batch':dialogDatepickerBatch
			'dialog-discard': dialogDiscard,
			'dialog-number-series': dialogNumberSeries,
			'dialog-select-batch':dialogSelectBatch,
			'dialog-datepicker-batch':dialogDatePickerBatch,
			'dialog-addons':dialogAddOns,
			'dialog-confirmation':dialogConfirmation,
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){

                     let name = this.Form.fromGodownName ? this.Form.fromGodownName : 'Stock_Transfer';

                     if(!this.unwatch){
                     	this.fn_saveDraft(name);
                     }
                     this.unwatch = false;
                 },
                 deep: true
            }
		},
		methods:{

			fn_openDatePicker: function (type, date) {
				let self = this;
				this.dateType = type;
				this.selectedDate = date ? date : this.$root.fn_getLocalDateFormat();
				setTimeout(function () {
					if(type=='mfgDate' || type=='expDate'){
						self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePickerBatch');	
					}
					else{
						self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePicker');
					}
				})
				// setTimeout(function () {
				// 	self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePickerBatch');
				// })
			},

			fn_updateBatchDate: function (value) {
				if(this.dateType == 'mfgDate' || this.dateType == 'expDate'){
					this.$refs['ref_dialogSelectBatch'].fn_updateDate(value, this.dateType);
				}
				else{
					this.$refs['ref_dialogSelectBatch'].fn_updateDate(value, this.dateType);
				}
				this.fn_closeDialog();
			},


			fn_updateDate: function (value) {
				// this.Form.transactionData.transactionDate = value;
				// this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(value);
				// this.Form.isNew ? this.fn_bindTransactionNumber() : '';
				this.fn_updateTransactionDate(value, this.Form.isNew);
				this.fn_closeDialog();
			},

            fn_updateFromGodown: function(selectedId, selectedName, isRemoved){
				if(!isRemoved){
					this.Form.fromGodownId = selectedId;
                	this.Form.fromGodownName = selectedName;
				}
				else{
					this.Form.fromGodownId = null;
                	this.Form.fromGodownName = null;
				}
                
            },

            fn_updateToGodown: function(selectedId, selectedName, isRemoved){
				if(!isRemoved){
					this.Form.toGodownId = selectedId;
					this.Form.toGodownName = selectedName;
				}
				else{
					this.Form.toGodownId = null;
					this.Form.toGodownName = null;
				}
            },

            fn_openProducts: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Item";
				viewDialogObject.groupTypeId = productGroupTypeId.product;
                let menuItemCustom = {"MenuID":1, "Icon":null, "Text":"New", "Action":"newproduct"};
				viewDialogObject.TopMenu = [menuItemCustom];
				viewDialogObject.isBottomMenu = false;
				viewDialogObject.hideChip = true;
				viewDialogObject.inventory = 1;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.productId && this.Form.productName){
					paramObject.defaultValue = {"id":this.Form.productId, "name":this.Form.productName};
				}

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'product', tagId, paramObject, ref);
			},

            fn_updateProduct: function (id, name, batches, isEdit) {
				this.Form.productId = id;
				this.Form.productName = name;
				this.fn_getProductData(id, batches, isEdit);
				this.$forceUpdate();
			},

			fn_getSummaryGodownWise: function (itemId) {
				var self = this;
				let filterObj = {};
				filterObj.godownId = this.Form.fromGodownId;
				filterObj.productId = itemId;
				this.getFilterData('ProductSummary', null, filterObj, 
					{
						onSuccess: function(response){
							console.log(response);
							self.Form.summaryArray = JSON.parse(response);
						}, 
						onError: function(error){
						console.log(error);
						}
					}
				);
			},

			// fn_getSummary: function (itemId) {
			// 	var self = this;
			// 	this.getData('ProductSummary', itemId, 
			// 		{
			// 			onSuccess: function(response){
			// 				console.log(response);
			// 				self.Form.summaryArray = JSON.parse(response);
			// 	        }, 
			// 	        onError: function(error){
			// 	          console.log(error);
			// 	        }
			// 		}
		    //     );
			// },

			fn_getProductData: function (itemId, batches, isEdit) {
				var self = this;
				this.getData('Product', itemId, 
					{
						onSuccess: function(response){
				          	console.log(response);
				          	self.Form.productData = JSON.parse(response);
				          	// if(!isEdit){
				          	// 	self.rate = self.Form.productData.purchaseRate;
				          	// }

							if(self.Form.productData.groupTypeId==101){
								self.fn_getBatches(self.Form.productData.productId, batches);
							}
				          	
				          	// self.fn_getSummary(itemId);
							self.fn_getSummaryGodownWise(itemId);

							if(!isEdit){
								self.fn_getAverageRate(itemId);
							}

							// self.fn_getBatches(itemId);

							// if(self.Form.productData.productVariants[0].secondaryUnitId){
							// 	if(isEdit){
							// 		if(tProducts && tProducts.length && tProducts[0].variants.length){
							// 			self.Form.selectedUnit = {};
							// 			self.Form.selectedUnit.itemId = tProducts[0].variants[0].unitId;
							// 			self.Form.selectedUnit.itemName = tProducts[0].variants[0].unitName;	
							// 		}
							// 	}
							// 	else{
							// 		self.Form.selectedUnit = {};
							// 		self.Form.selectedUnit.itemId = self.Form.productData.productVariants[0].unitId;
							// 		self.Form.selectedUnit.itemName = self.Form.productData.productVariants[0].unitName;
							// 	}
								
							// }
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getAverageRate: function(itemId){
				let self = this;
				let filterObject = {};
				filterObject.productId = itemId;
				filterObject.GSTRegistrationStatus = this.$root.CurrentBusiness.GSTRegistrationStatus;
				filterObject.endDate = this.Form.transactionData.transactionDate;
				this.getFilterData('GetProductAverageRate', null, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							self.$nextTick(() => {
								if(response){
									self.Form.averageRate = self.roundUpto2Decimals(Number(response));
								}
								else{
									self.Form.averageRate = null;
								}
							})
				        }, 
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
			},

			fn_getBatches: function(productId, addedBatches){
				let self = this;
				this.getData('GetProductBatchByProductId', productId, 
					{
						onSuccess: function(response){
							console.log(response);
							self.$set(self.Form, 'batches', JSON.parse(response));

							if(addedBatches && addedBatches.length){
								self.$set(self.Form.productData, 'batches', JSON.parse(JSON.stringify(addedBatches)));

								for(let i=0; i<addedBatches.length; i++){
									let bIndex = self.Form.batches.findIndex(bItem=>{return bItem.batchId == addedBatches[i].batchId});
									if(bIndex == -1){
										self.Form.batches.push(addedBatches[i]);
									}
								}
							}
							// if(self.$parent.Form.Form.productData.batches && self.$parent.Form.Form.productData.batches.length){
							// 	self.$parent.fn_openDialogWeb('web', 'Batches', 'ref_dialogSelectBatch');
							// }
						}, 
						onError: function(error){
							console.log(error);
						}
					}
				);
			},
			fn_openDialogSelectBatch: function(){
				for(let i=0; i<this.Form.batches.length; i++){
                    this.Form.batches[i].selected = false;
                    this.Form.batches[i].productQty = null;
                }

				if(this.Form.productData.batches && this.Form.productData.batches.length){
					for(let i=0; i<this.Form.batches.length; i++){
						this.Form.batches[i].productQty = null;
						this.Form.batches[i].selected = false;
						for(let j=0; j<this.Form.productData.batches.length; j++){
							if(this.Form.productData.batches[j].batchId == this.Form.batches[i].batchId){
								if(this.Form.productData.batches[j].productQty){
									this.Form.batches[i].selected = true;
									this.Form.batches[i].productQty = this.Form.productData.batches[j].productQty;
								}
							}
						}
					}
				}

				// if(this.Form.productBatches && this.Form.productBatches.length){
				// 	for(let i=0; i<this.Form.batches.length; i++){
				// 		this.Form.batches[i].productQty = null;
				// 		this.Form.batches[i].selected = false;
				// 		for(let j=0; j<this.Form.productBatches.length; j++){
				// 			if(this.Form.productBatches[j].batchId == this.Form.batches[i].batchId){
				// 				if(this.Form.productBatches[j].productQty){
				// 					this.Form.batches[i].selected = true;
				// 					this.Form.batches[i].productQty = this.Form.productBatches[j].productQty;
				// 				}
				// 			}
				// 		}
				// 	}
				// }
				this.fn_openDialogWeb('web', 'Batches', 'ref_dialogSelectBatch');
			},
			fn_showHideBatches: function(field){
				if(this.Form.selectedBatchType == 2 && !field.batchNumber && !field.batchMRP && !field.batchSize && !field.mfgDate && !field.expDate && !field.field4){
					return true;
				}
				else if(this.Form.selectedBatchType == 1 && !field.field1 && !field.field2 && !field.field3){
					return true;
				}
				else{
					return false;
				}
			},
			fn_newBatch: function(){
				this.backButtonPress = false;
				this.$router.push({path:"/product/batches", query:{pid:this.Form.productData.productId, dialog:1, new:1}});
			},
			fn_changeProductQty: function(item){
				if(this.Form.productData.batches && this.Form.productData.batches.length && this.Form.productData.batches.length == 1){
					this.Form.productData.batches[0].productQty = item.qty;
				}
			},
			fn_changeBatchQty: function(){
				if(this.Form.productData.batches && this.Form.productData.batches.length){
					let totalVal = 0;
					for(let i=0; i<this.Form.productData.batches.length; i++){
						totalVal += this.Form.productData.batches[i].productQty;
					}
					this.Form.qty = Number(totalVal);
				}
			},

			fn_removeBatch: function(batchIndex){
				this.Form.productData.batches.splice(batchIndex, 1);
				let totalQty = 0;
				for(let i=0; i<this.Form.productData.batches.length; i++){
					totalQty = totalQty + Number(this.Form.productData.batches[i].productQty);
				}
				this.Form.productData.productVariants[0].qty = totalQty ? totalQty : null;
				this.Form.qty = totalQty;
				// this.$forceUpdate();
			},

			fn_appendBatches: function(batches){
				if(batches.length){
					// for(let i=0; i<batches.length; i++){
					// 	if(!this.Form.productData.items[0].batches || !this.Form.productData.items[0].batches.length){
					// 		this.Form.productData.items[0].batches = [];
					// 	}
					// 	let bIndex = this.Form.productData.items[0].batches.findIndex(bat=>{return bat.batchId === batches[i].batchId});
					// 	if(bIndex != -1){
					// 		this.Form.productData.items[0].batches[bIndex] = JSON.parse(JSON.stringify(batches[i]));
					// 	}
					// 	else{
					// 		this.Form.productData.items[0].batches.push(JSON.parse(JSON.stringify(batches[i])));
					// 	}
					// 	this.$forceUpdate();
					// }
					this.$set(this.Form.productData, 'batches', JSON.parse(JSON.stringify(batches)));
					// this.Form.productData.items[0].batches = JSON.parse(JSON.stringify(batches));
					let totalQty = 0;

					let bat = null;
					if(this.Form.selectedBatchType == 2){
						bat = batches.filter(field=>{
							return !field.batchNumber && !field.batchMRP && !field.purchaseRate && !field.batchSize && !field.mfgDate && !field.expDate && !field.field4
						})

						if(this.Form.productData){
							if(this.Form.productData.productVariants[0].selectedUnit){
								this.Form.productData.productVariants[0].selectedUnit = {"itemId":this.Form.productData.productVariants[0].primaryUnitId, "itemName":this.Form.productData.productVariants[0].primaryUnitName}
							}
						}
					}
					else{
						bat = batches.filter(field=>{
							return !field.field1 && !field.field2 && !field.field3
						})

						if(batches.length == 1 && batches[0].batchMRP){
							if(this.$root.TransactionSettings.mrpWiseStock && this.$root.TransactionSettings.mrpAsSalePrice && this.Form.productData.mrp){
								this.$set(this.Form.productData, 'rate', Number(batches[0].batchMRP));
							}
						}
					}
					
					for(let i=0; i<bat.length; i++){
						totalQty += Number(bat[i].productQty);
					}
					// this.Form.productData.items[0].productVariants[0].qty = Number(totalQty);
					this.$set(this.Form, 'qty', Number(totalQty));
					this.$set(this.Form.productData.productVariants[0], 'qty', Number(totalQty));
				}
				this.fn_closeDialog();
			},

			fn_fieldVisibilty: function(field, selectedBatchType){
				if(field.status){
					if(selectedBatchType == 2){
						if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
							return true;
						}
						else{
							return false;
						}
					}
					else{
						if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'opening' || field.id == 'field4'){
							return true;
						}
						else{
							return false;
						}
					}
				}
				else{
					return false
				}
			},
			

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
                console.log(ref);
                if(ref == 'ref_fieldProductName'){
                    this.fn_updateProduct(selectedValueId, selectedValueName, isRemoved);
                }
				else if(ref == 'ref_dialogAddOns_name'){
					this.fn_closeDialog();
					setTimeout(() => {
						this.fn_openDialogWeb('web', 'AddOnsForm', 'ref_dialogAddOns');
					}, 300);
					setTimeout(() => {
						this.$refs['ref_dialogAddOns'].fn_updateAddOns(selectedValueId, selectedValueName, false);
					}, 500);
				}
                else{
                    this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
                }
				// this.fn_updateProduct(selectedValueId, selectedValueName, isRemoved);
			},


			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_getData: function (itemId) {
				let self = this;
				this.Form.isNew = false;
				this.getData('GetStockTransfer', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);
							self.fn_bindData(data);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_bindData: function (data) {
				// this.fn_getTransactionTypeData(data.transactionTypeFormId, null, false);
				this.Form.transactionData.additionalData = data.additionalData;
				this.Form.transactionData.amount = data.amount;
				this.Form.transactionData.businessId = data.businessId;
				this.Form.transactionData.createdBy = data.createdBy;
				this.Form.transactionData.createdDate = data.createdDate;
				this.Form.transactionData.currencyId = data.currencyId;
				this.Form.transactionData.dueDate = data.dueDate;
				this.Form.transactionData.dueType = data.dueType;
				this.Form.transactionData.modifiedBy = data.modifiedBy;
				this.Form.transactionData.modifiedDate = data.modifiedDate;
				this.Form.transactionData.notes = data.notes;
				this.Form.transactionData.partyId = data.partyId;
				this.Form.transactionData.paymentMode = data.paymentMode;
				this.Form.transactionData.prefix = data.prefix;
				this.Form.transactionData.refDate = data.refDate;
				this.Form.transactionData.refNumber = data.refNumber;
				this.Form.transactionData.roundedAmount = data.roundedAmount;
				this.Form.transactionData.salesmanId = data.salesmanId;
				this.Form.transactionData.status = data.status;
				this.Form.transactionData.suffix = data.suffix;
				this.Form.transactionData.transactionDate = data.transactionDate;
				this.Form.transactionData.transactionId = data.transactionId;
				this.Form.transactionData.transactionListId = data.transactionListId;
				this.Form.transactionData.transactionNumber = data.transactionNumber;
				this.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
				// this.Form.transactionProductsTemp = JSON.parse(JSON.stringify(data.transactionProducts));
				// this.Form.transactionProducts = JSON.parse(JSON.stringify(data.transactionProducts));
                this.Form.transactionProducts = [];
                for(let i=0; i<data.transactionProducts.length; i++){
                    let itemIndex  = this.Form.transactionProducts.findIndex(item=>{return item.productId == data.transactionProducts[i].productId})
                    if(itemIndex==-1){
                        data.transactionProducts[i].qty = data.transactionProducts[i].productVariants[0].qty;
                        data.transactionProducts[i].unitId = data.transactionProducts[i].productVariants[0].unitId;
                        data.transactionProducts[i].unitName = data.transactionProducts[i].productVariants[0].unitName;
                        data.transactionProducts[i].productVariantId = data.transactionProducts[i].productVariants[0].productVariantId;
                        data.transactionProducts[i].primaryUnitId = data.transactionProducts[i].productVariants[0].primaryUnitId;
                        data.transactionProducts[i].secondaryUnitId = data.transactionProducts[i].productVariants[0].secondaryUnitId;
                        data.transactionProducts[i].packQuantity = data.transactionProducts[i].productVariants[0].packQuantity;
                        data.transactionProducts[i].secondaryUnitPackQuantity = data.transactionProducts[i].productVariants[0].secondaryUnitPackQuantity;
                        data.transactionProducts[i].averageRate = data.transactionProducts[i].rate;
						
						data.transactionProducts[i].batches = [];

						if(data.transactionProducts[i].transactionProductBatches && data.transactionProducts[i].transactionProductBatches.length){
							for(let j=0; j<data.transactionProducts[i].transactionProductBatches.length; j++){
								data.transactionProducts[i].transactionProductBatches[j].productQty = data.transactionProducts[i].transactionProductBatches[j].qty;
								data.transactionProducts[i].batches.push(data.transactionProducts[i].transactionProductBatches[j]);
							}
						}
						// data.selectedBatchType =  data.transactionProducts[i].selectedBatchType;

						this.Form.transactionProducts.push(data.transactionProducts[i]);
                    }
                }

				this.Form.transactionAddOns = [];

				if(data.transactionAddOns && data.transactionAddOns.length){
					let self = this;
					data.transactionAddOns.forEach(function (item) {

						item.mode == 1 ? item.percentage = null : '';

						let addOnsItem = JSON.parse(JSON.stringify(item));
						
						self.Form.transactionAddOns.push(addOnsItem);

					});

				}

				
                this.Form.fromGodownId = data.fromGodownId;
                this.Form.fromGodownName = data.fromGodownName;
                this.Form.toGodownId = data.toGodownId;
                this.Form.toGodownName = data.toGodownName;
				// this.Form.rate = products[0].variants[0].rate;
				// this.Form.qty = products[0].variants[0].qty;
				// this.type = products[0].variants[0].transactionProductMode ? 'plus' : 'minus';

				// this.Form.selectedBatchType = products[0].selectedBatchType;

				// if(products[0].transactionProductBatches && products[0].transactionProductBatches.length){
				// 	this.Form.productBatches = [];
				// 	for(let i=0; i<products[0].transactionProductBatches.length; i++){
				// 		products[0].transactionProductBatches[i].productQty = products[0].transactionProductBatches[i].qty;
				// 		this.Form.productBatches.push(JSON.parse(JSON.stringify(products[0].transactionProductBatches[i])))
				// 	}
				// }

				// this.fn_getProductData(data.productId, true, products);

				// this.Form.transactionTypeFormId = data.transactionTypeFormId;
				// this.Form.transactionTypeFormName = data.transactionTypeFormName;

				// this.Form.transactionData.numberSeriesId = data.numberSeriesId;
				// this.Form.transactionData.transactionNumberId = data.transactionNumberId;

				// let self = this;
				// this.Form.transactionProductsTemp.forEach(function (item) {
				// 	item.transactionProductMode = item.variants[0].transactionProductMode;
				// 	self.fn_getGroupTotal(item);
				// });

				// setTimeout(function(){
				// 	self.$root.fn_copyFormObject(self.Form, self.formId);
				// },500);
			},

			fn_checkValidations: function(){
				if(this.Form.fromGodownId == this.Form.toGodownId){
					this.showToast("Both godowns cannot be same.");
					return;
				}

				if(!this.Form.transactionProducts || (this.Form.transactionProducts && !this.Form.transactionProducts.length)){
					this.showToast("Add items");
					return;
				}

				this.disabledBtn = true;
				this.showLoading('Please Wait...');
				this.$validator.validateAll().then((result) => {
			        if (result) {
						this.fn_checkTransactionNumber(()=>{
			        		this.fn_post();
			        	});
			    	}
			    	else{
			    		this.disabledBtn = false;
			    		this.hideLoading();
			    	}
			    });
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('PostStockTransfer', dataObj, 
					{
						onSuccess: function(response){
				          	console.log(response);

							// let adjustmentType = self.type == 'minus' ? 'stock_reduced' : 'stock_added'; 

							// // posting metrics on save
							// let postObj = {"eventName":'stock_adjustment_save',"eventData":[{"eventKey":"adjust_type","eventValue":adjustmentType}]}
				          	
							// let saveObj = {};
							// saveObj.eventKey = "transaction_save";
							// saveObj.eventValue = adjustmentType;
							// postObj.eventData.push(saveObj);
							
							// self.$root.fn_postMetrics(postObj);
							self.fn_cleanUp();
							// self.fn_goBack();
				        },
				        onError: function(error){
				          	console.log(error);
				          	self.hideLoading();
				          	let response = JSON.parse(error);
				         	if(response && response.negativeProducts && response.negativeProducts.length){
				         		self.fn_shortListInvalidItems(response.negativeProducts);
				         	}
				        }
					}
		        );
			},

            fn_cleanUp: function () {
				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					self.hideLoading();
					// self.$router.go(-1);
					self.fn_previewInvoice(false, "inventory", 'st', null, 'Stock Transfer');
				});
			},

			fn_post: function(){

				//only in case of new transaction
				if(!this.Form.transactionData.transactionId){
					this.Form.transactionData.transactionId = this.guid();
					// this.Form.transactionData.createdDate = new Date();
					this.Form.transactionData.createdDate = this.$root.fn_getLocalDateFormat();
					this.Form.transactionData.transactionListId = this.settings.transactionTypeId;
				}

				// this.Form.transactionData.modifiedDate = new Date();
				this.Form.transactionData.modifiedDate = this.$root.fn_getLocalDateFormat();

				this.Form.transactionData.amount = this.totalAmount;
				this.Form.transactionData.roundedAmount = this.totalAmount;
				this.Form.transactionData.status = 1;
				this.Form.transactionData.transactionTypeFormId = this.Form.transactionTypeFormId;
				this.Form.transactionData.refDate = null;

                this.Form.transactionData.fromGodownId = this.Form.fromGodownId;
                this.Form.transactionData.toGodownId = this.Form.toGodownId;

				let postObj = {};
				postObj = this.Form.transactionData;
				postObj.masterProductBatches = [];
				postObj.transactionProductBatches = [];
				
				let transactionProducts = [];

                // process for from godown
                this.fn_processTransactionProducts('from', transactionProducts, postObj);
                // process for to godown
                this.fn_processTransactionProducts('to', transactionProducts, postObj);

				postObj.transactionProducts = transactionProducts;

				// postObj.masterProductBatches = [];
				// postObj.transactionProductBatches = [];

				postObj.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));
				postObj.sortDate = this.$moment(this.Form.transactionData.transactionDate).format('YYYY-MM-DD');

				// if(this.Form.selectedBatchType == 2){
				// 	this.Form.productBatches = this.Form.productBatches.filter(batch=>{
				// 		return batch.field1 || batch.field2 || batch.field3
				// 	})
				// }
				// else{
				// 	this.Form.productBatches = this.Form.productBatches.filter(batch=>{
				// 		return !batch.field1 && !batch.field2 && !batch.field3
				// 	})
				// }

				// if(this.Form.productBatches && this.Form.productBatches.length){
				// 	//adding batches to transaction
				// 	for(let i=0; i<this.Form.productBatches.length; i++){
				// 		let obj = {};
				// 		obj.productId = this.Form.productData.productId;
				// 		obj.transactionProductBatchId = this.guid();
				// 		obj.batchId = this.Form.productBatches[i].batchId;
				// 		obj.transactionProductId = tpObj.transactionProductId;
				// 		obj.qty = this.Form.productBatches[i].productQty;
				// 		obj.orderNumber = i + 1;
				// 		obj.transactionId = this.Form.transactionData.transactionId;
				// 		obj.transactionListId = this.Form.transactionData.transactionListId;
				// 		if(this.type == 'minus'){
				// 			obj.actualQty = -this.Form.productBatches[i].productQty;
				// 		}
				// 		else{
				// 			obj.actualQty = this.Form.productBatches[i].productQty;
				// 		}

				// 		if(this.Form.selectedUnit && this.Form.selectedUnit.itemId && this.Form.selectedUnit.itemId != tpObj.primaryUnitId){
				// 			obj.actualQty = this.roundUpto5Decimals((obj.actualQty * tpObj.packQuantity) / this.Form.productData.productVariants[0].secondaryUnitPackQuantity);
				// 		}
						
				// 		postObj.transactionProductBatches.push(obj);

				// 		if(this.Form.productBatches[i].isNew){
				// 			delete this.Form.productBatches[i].isNew;
				// 			this.Form.productBatches[i].productId = this.Form.productData.productId;
				// 			this.Form.productBatches[i].orderNumber = this.Form.batches.length + (i + 1);
				// 			postObj.masterProductBatches.push(this.Form.productBatches[i]);
				// 		}
				// 	}
				// }

				postObj.transactionAddOns = [];

				if(this.Form.transactionAddOns.length){

					this.Form.transactionAddOns.forEach(function (addOnsItem, index) {
						
						let addOnsObj = {};

						if(addOnsItem.value!==null && addOnsItem.value!==''){

							addOnsObj.transactionAddOnsId = addOnsItem.transactionAddOnsId;
							addOnsObj.orderNumber = index+1;
							addOnsObj.addOnsId = addOnsItem.addOnsId;

							//saving name, nature and mode for display purpose only
							addOnsObj.addOnsName = addOnsItem.name;
							addOnsObj.addOnsNature = addOnsItem.nature;
							addOnsObj.addOnsMode = addOnsItem.mode;

							addOnsObj.addOnsType = addOnsItem.addOnsType;
							addOnsObj.percentage = addOnsItem.percentage;
							addOnsObj.value = addOnsItem.value;
							addOnsObj.appliedOn = addOnsItem.appliedOn;
							addOnsObj.adjustInTotal = addOnsItem.adjustInTotal;

							addOnsObj.isDefault = addOnsItem.isDefault;

							if(addOnsItem.addOnsType==2 && (addOnsItem.addOnsId == fixedGstAddOns.CGST.id || addOnsItem.addOnsId == fixedGstAddOns.SGST.id || addOnsItem.addOnsId == fixedGstAddOns.UTGST.id || addOnsItem.addOnsId == fixedGstAddOns.IGST.id)){
								addOnsObj.isGst = 1;
							}

							postObj.transactionAddOns.push(addOnsObj);
						}

					})
				}
				
				console.log(this.Form);
				this.fn_saveLocal(postObj);
			},

            fn_processTransactionProducts: function(type, transactionProducts, postObj){
                for(let i=0; i<this.Form.transactionProducts.length; i++){
                    let tpObj = {};
                    tpObj.transactionProductId = this.guid();
                    tpObj.transactionId = this.Form.transactionData.transactionId;
                    tpObj.productId = this.Form.transactionProducts[i].productId;
                    tpObj.productVariantId = this.Form.transactionProducts[i].productVariantId;
                    tpObj.groupId = this.guid();
                    tpObj.mrp = null;
                    tpObj.rate = this.Form.transactionProducts[i].averageRate ? this.Form.transactionProducts[i].averageRate : null;
                    tpObj.additionalData = null;
                    tpObj.unitId = this.Form.transactionProducts[i].unitId;
                    tpObj.primaryUnitId = this.Form.transactionProducts[i].primaryUnitId ? this.Form.transactionProducts[i].primaryUnitId : this.Form.transactionProducts[i].unitId;
                    if(this.Form.transactionProducts[i].secondaryUnitId){
                        tpObj.secondaryUnitId = this.Form.transactionProducts[i].secondaryUnitId	
                    }

                    if(this.Form.transactionProducts[i].secondaryUnitPackQuantity){
                        tpObj.secondaryUnitPackQuantity = this.Form.transactionProducts[i].secondaryUnitPackQuantity;	
                    }

                    tpObj.qty = this.Form.transactionProducts[i].qty;
                    tpObj.packQuantity = this.Form.transactionProducts[i].packQuantity ? this.Form.transactionProducts[i].packQuantity : 1;
                    tpObj.amount = this.roundUpto2Decimals(tpObj.rate * tpObj.qty);
					tpObj.netAmount = this.roundUpto2Decimals(tpObj.rate * tpObj.qty);
                    tpObj.taxableValue = this.roundUpto2Decimals(tpObj.rate * tpObj.qty);

                    if(type == 'from'){
                        tpObj.fromGodownId = this.Form.fromGodownId;
                        tpObj.transactionProductMode = 0;
                        tpObj.actualQty = -this.Form.transactionProducts[i].qty;
                    }
                    else{
                        tpObj.toGodownId = this.Form.toGodownId;
                        tpObj.transactionProductMode = 1;
                        tpObj.actualQty = this.Form.transactionProducts[i].qty;
                    }

					tpObj.selectedBatchType = this.Form.transactionProducts[i].selectedBatchType;
                    
                    // tpObj.selectedBatchType = this.Form.selectedBatchType;

                    // if(this.Form.selectedUnit && this.Form.selectedUnit.itemId && this.Form.selectedUnit.itemId != tpObj.primaryUnitId){
                    //     tpObj.actualQty = this.roundUpto5Decimals((tpObj.actualQty * tpObj.packQuantity) / this.Form.productData.productVariants[0].secondaryUnitPackQuantity);
                    // }

					// tpObj.fromGodownId = this.Form.fromGodownId;
					// tpObj.toGodownId = this.Form.toGodownId;

					tpObj.stockInventory = true;

                    transactionProducts.push(tpObj);

					if(this.Form.transactionProducts[i].batches && this.Form.transactionProducts[i].batches.length){
						//adding batches to transaction
						let item = this.Form.transactionProducts[i];
						for(let i=0; i<item.batches.length; i++){
							let obj = {};
							obj.productId = tpObj.productId;
							obj.transactionProductBatchId = !this.Form.isNew && item.batches[i].transactionProductBatchId ? item.batches[i].transactionProductBatchId : this.guid();
							obj.batchId = item.batches[i].batchId;
							obj.transactionProductId = tpObj.transactionProductId;
							obj.qty = item.batches[i].productQty;
							obj.orderNumber = i + 1;
							obj.transactionId = this.Form.transactionData.transactionId;
							obj.transactionListId = this.Form.transactionData.transactionListId;

							if(tpObj.refTId){
								obj.refTId = tpObj.refTId;
								if(item.baseTransactionListId != transactionTypes.order.id){
									if(item.batches[i].refTpBatchId){
										obj.refTpBatchId = item.batches[i].refTpBatchId;
									}
									else if(item.batches[i].refTransactionProductBatchId){
										obj.refTpBatchId = item.batches[i].refTransactionProductBatchId;
									}
									else{
										obj.refTpBatchId = item.batches[i].transactionProductBatchId;
									}
								}
							}

							obj.actualQty = type == 'from' ? -item.batches[i].productQty : item.batches[i].productQty;

							// if(item.productVariants[0].selectedUnit && item.productVariants[0].selectedUnit.itemId != item.productVariants[0].primaryUnitId){
							// 	obj.actualQty = self.roundUpto5Decimals((obj.actualQty * item.productVariants[0].packQuantity) /item.productVariants[0].secondaryUnitPackQuantity);
							// }

							postObj.transactionProductBatches.push(obj);

							if(item.batches[i].isNew){
								delete item.batches[i].isNew;
								item.batches[i].productId = tpObj.productId;
								item.batches[i].orderNumber = this.Form.batches.length + (i + 1);
								postObj.masterProductBatches.push(item.batches[i]);
							}
						}
					}
                }
            },

			fn_addNote: function () {
				this.$refs['ref_dialogNote'].noteValue = this.Form.transactionData.notes;
				this.fn_openDialogWeb('web', 'Note', 'ref_dialogNote');
				setTimeout(function(){
					let noteField = document.getElementById('noteField');
					noteField.focus();
				});
			},

			fn_saveNote: function () {
				this.Form.transactionData.notes = this.$refs['ref_dialogNote'].noteValue;
				this.fn_closeDialog();
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

            fn_menuItemClick: function(tagId, menuId, menuAction){
				this.backButtonPress = false;
				if(menuAction == 'fromgodown'){
					this.$router.push({'path':'/masters/inventory/godown/items/new', query:{tagId:this.guidWeb(), ls:1, type:'fromgodown'}})
				}
                else if(menuAction == 'togodown'){
					this.$router.push({'path':'/masters/inventory/godown/items/new', query:{tagId:this.guidWeb(), ls:1, type:'togodown'}})
				}
                else if(menuAction == 'newproduct'){
					this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), ls:1}})
				}
				else if(menuAction=='addothercharges'){
					this.$router.push({path:'/addons/othercharges/new', query:{tagId:this.guidWeb(), ls:1}});
				}
            },

            fn_setNewItem: function(){
				if(localStorage.getItem('newItem')){

					let itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
						case "fromgodown":
					    	this.fn_updateFromGodown(itemData.id, itemData.name, false);
					        break;
                        case "togodown":
					    	this.fn_updateToGodown(itemData.id, itemData.name, false);
					        break;
                        case "product":
					    	this.fn_updateProduct(itemData.id, itemData.name, false);
					        break;
						case "otherCharges":
							this.fn_setNewAddOns(itemData.id, itemData.name, false);
							break;
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}

				this.Form.isNew ? this.$root.fn_copyFormObject(this.Form, this.formId) : '';
			},

			// fn_appendBatches: function(batches){
			// 	if(batches.length){
			// 		this.$set(this.Form, 'productBatches', JSON.parse(JSON.stringify(batches)));
			// 		// this.Form.Form.productData.items[0].batches = JSON.parse(JSON.stringify(batches));
			// 		let totalQty = 0;
			// 		for(let i=0; i<this.Form.productBatches.length; i++){
			// 			totalQty += Number(this.Form.productBatches[i].productQty);
			// 		}
			// 		this.Form.qty = Number(totalQty);

			// 		if(this.Form.productData && this.Form.selectedBatchType == 2){
			// 			this.Form.selectedUnit = {"itemId":this.Form.productData.productVariants[0].unitId, "itemName":this.Form.productData.productVariants[0].unitName};
			// 		}
			// 	}
			// 	this.fn_closeDialog();
			// },

			fn_showHideBatches: function(field){
				if(this.Form.selectedBatchType == 2 && !field.batchNumber && !field.batchMRP && !field.batchSize && !field.mfgDate && !field.expDate && !field.opening && !field.field4){
					return true;
				}
				else if(this.Form.selectedBatchType == 1 && !field.field1 && !field.field2 && !field.field3){
					return true;
				}
				else{
					return false;
				}
			},

			// fn_unitChange: function(value, item){
			// 	let currentItemId = this.$refs.ref_unitSelection[0]._data.selectedItems[0].itemId;
			// 	if(currentItemId != value.itemId){
			// 		if(value.itemId == item.secondaryUnitId){
			// 			this.Form.rate = this.roundUpto2Decimals(this.Form.rate / item.secondaryUnitPackQuantity);
			// 		}
			// 		else{
			// 			this.Form.rate = this.roundUpto2Decimals(this.Form.rate * item.secondaryUnitPackQuantity);
			// 		}
			// 	}
			// },

			fn_unitChange: function(value, item){
				let currentItemId = this.$refs.ref_unitSelection[0]._data.selectedItems[0].itemId;
				if(currentItemId != value.itemId){
					if(value.itemId == item.secondaryUnitId){
						this.Form.rate = (this.Form.rate * item.packQuantity) / item.secondaryUnitPackQuantity;

					}
					else{
						this.Form.rate = (this.Form.rate * item.secondaryUnitPackQuantity) / item.packQuantity;
						// product.rate = this.roundUpto2Decimals(product.rate * item.secondaryUnitPackQuantity);
					}
					// this.tempRate = this.Form.rate;
					this.Form.rate = this.roundUpto2Decimals(this.Form.rate); 
				}
			},

			// fn_assignTempValue: function(val){
			// 	this.tempRate = val;
			// },

			fn_changeBatchType: function(val){
				if(val==2 && this.Form.productData.batches && this.Form.productData.batches.length){
					if(this.Form.selectedUnit){
						this.Form.selectedUnit = {"itemId":this.Form.productData.productVariants[0].unitId, "itemName":this.Form.productData.productVariants[0].unitName}
					}
				}
			},

            fn_addProduct: function(type, index){
				if(!this.Form.fromGodownId){
					this.showToast("Select From Godown");
					return;
				}

				this.Form.selectedItemIndex = type == 'edit' ? index : null;

                this.Form.productId = null;
                this.Form.productName = null;
                this.Form.qty = null;
				this.Form.averageRate = null;
                this.Form.productData = null;
                this.Form.summaryArray = [];
                this.fn_openDialogWeb('web', 'Product', 'ref_dialogProduct');
            },

            fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			fn_openAddOns: function (addOnsType, isNew) {
				if(isNew){
					localStorage.setItem('newSelection', 1);
					
					this.Form.addOnsDataModel = {"transactionTypeAddOnsId":null, "addOnsId":null, "name":null, "percentage":null, "value":null, "mode":null, "nature":null, "appliedOn":0, "adjustInTotal":true, "orderNumber":null, "addOnsType":addOnsType};

					this.fn_openAddOnsList('android', 'AddOns', 'ref_dialogAddOns_name', null, null, addOnsType);
				}
				else{
					this.fn_openDialogWeb('web', 'AddOnsForm', 'ref_dialogAddOns');
				}
			},

			fn_openAddOnsList: function (platform, name, ref, itemId, itemName, addOnsType) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var self = this;

				var viewDialogObject = {};
				this.Form.addOnsProp.addOnsType = addOnsType;

				// let actionValue = null;
				if(addOnsType == 1){
					this.Form.addOnsProp.toolbarTitle = "Discounts";
					viewDialogObject.TopMenu = [menuItem.addDiscount];
					// actionValue = "adddiscount";
				}
				else if(addOnsType == 2){
					this.Form.addOnsProp.toolbarTitle = "Taxes";
					viewDialogObject.TopMenu = [menuItem.addTaxes];
					// actionValue = "addtaxes";
				}
				else{
					this.Form.addOnsProp.toolbarTitle = "Other Charges";
					viewDialogObject.TopMenu = [menuItem.addOtherCharges];	
					// actionValue = "addothercharges";
				}

				viewDialogObject.ToolbarTitle = this.Form.addOnsProp.toolbarTitle;

				viewDialogObject.isBottomMenu = false;
				viewDialogObject.hideChip = true;
				viewDialogObject.addOnType = Number(addOnsType);

				var paramObject = {};
				paramObject.defaultValue = {"id":itemId, "name":itemName};

				console.log(JSON.stringify(viewDialogObject));

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, "addOns", tagId, paramObject, ref);
			},

			fn_saveAddOns: function (data) {

				console.log(JSON.stringify(data));

				// this.Form.newSelection = false;
				localStorage.removeItem('newSelection');

				if(data.mode==0 && (data.percentage==null || data.percentage=='')){
					data.value = null;
				}

				if(!data.isDefault)
					data.isDefault = false;

				!data.transactionAddOnsId ? data.transactionAddOnsId = this.guid() : '';

				let itemIndex = this.Form.transactionAddOns.findIndex(item=>{
					return item.transactionAddOnsId == data.transactionAddOnsId || item.addOnsId == data.addOnsId;
				});

				if(data.addOnsType == 2){
					this.fn_checkTaxAddOns(data);	
				}
				else{
					let itemIndex = this.Form.transactionAddOns.findIndex(item=>{
						return item.transactionAddOnsId == data.transactionAddOnsId || item.addOnsId == data.addOnsId;
					});

					if(itemIndex==-1){
						this.Form.transactionAddOns.push(data);
					}
					else{
						this.Form.transactionAddOns.splice(itemIndex, 1, data);
					}

					this.fn_closeDialog();
				}
			},

			fn_checkTaxAddOns: function(data){
				let data2 = null
				if(this.Form.gstType == "IntraState" && (fixedGstAddOns.CGST.id == data.addOnsId || fixedGstAddOns.SGST.id == data.addOnsId)){
					data2 = JSON.parse(JSON.stringify(data));
					data2.transactionAddOnsId = this.guid();
					if(fixedGstAddOns.CGST.id == data.addOnsId){
						data2.addOnsId = fixedGstAddOns.SGST.id;
						// data2.saleAccountItemId = fixedAccountIds.outputSgst.id;
						data2.saleAccountItemId = fixedAccountIds.sgst.id;
						data2.name = "SGST";
					}
					else{
						data2.addOnsId = fixedGstAddOns.CGST.id;
						// data2.saleAccountItemId = fixedAccountIds.outputCgst.id;
						data2.saleAccountItemId = fixedAccountIds.cgst.id;
						data2.name = "CGST";
					}
				}
				else if(this.Form.gstType == "UnionTerritory" && (fixedGstAddOns.CGST.id == data.addOnsId || fixedGstAddOns.UTGST.id == data.addOnsId)){
					data2 = JSON.parse(JSON.stringify(data));
					data2.transactionAddOnsId = this.guid();
					if(fixedGstAddOns.CGST.id == data.addOnsId){
						data2.addOnsId = fixedGstAddOns.UTGST.id;
						// data2.saleAccountItemId = fixedAccountIds.outputUtgst.id;
						data2.saleAccountItemId = fixedAccountIds.utgst.id;
						data2.name = "UTGST";
					}
					else{
						data2.addOnsId = fixedGstAddOns.CGST.id;
						// data2.saleAccountItemId = fixedAccountIds.outputCgst.id;
						data2.saleAccountItemId = fixedAccountIds.cgst.id;
						data2.name = "CGST";
					}
				}

				let itemIndex = this.Form.transactionAddOns.findIndex(item=>{
					return item.transactionAddOnsId == data.transactionAddOnsId || item.addOnsId == data.addOnsId;
				});

				if(itemIndex==-1){
					this.Form.transactionAddOns.push(data);
				}
				else{
					this.Form.transactionAddOns.splice(itemIndex, 1, data);
				}

				if(data2){
					let data2Index = this.Form.transactionAddOns.findIndex(item=>{
						return item.addOnsId == data2.addOnsId;
					});

					if(data2Index==-1){
						this.Form.transactionAddOns.push(data2);
					}
					else{
						this.Form.transactionAddOns.splice(data2Index, 1, data2);
					}
				}

				this.fn_closeDialog();

			},

			fn_removeAddOns: function(item, index){
				let addOnIndex = this.Form.transactionAddOns.findIndex(addOnItem=>{
					return item.transactionAddOnsId == addOnItem.transactionAddOnsId;
				})

				// this.Form.transactionAddOns.splice(index, 1);
				this.Form.transactionAddOns.splice(addOnIndex, 1);

				if(item.addOnsId == fixedGstAddOns.CGST.id){
					let self = this;
					if(this.Form.gstType == "UnionTerritory"){
						this.fn_removeAddOnsPair(fixedGstAddOns.UTGST.id);
					}
					else{
						this.fn_removeAddOnsPair(fixedGstAddOns.SGST.id);
					}
				}
				else if(item.addOnsId == fixedGstAddOns.SGST.id || item.addOnsId == fixedGstAddOns.UTGST.id){
					this.fn_removeAddOnsPair(fixedGstAddOns.CGST.id);
				}
			},

			fn_removeAddOnsPair: function(addOnId){
				let itemIndex = this.Form.transactionAddOns.findIndex(item=>{
					return item.addOnsId == addOnId;
				})

				this.Form.transactionAddOns.splice(itemIndex, 1);
			},

			fn_editAddOns: function (item) {
				// this.Form.newSelection = false;
				localStorage.removeItem('newSelection');
				this.Form.addOnsDataModel = JSON.parse(JSON.stringify(item));
				this.fn_openAddOns(item.addOnsType);
			},

			fn_bindTransactionTypeAddOns: function (bindAll) {
				let self = this;
				let tempAddOns = null;

				if(bindAll){
					this.Form.productDataModel.addOnsItems = [];
					// !dont remove as will be useful if transaction form open for user
					// this.Form.transactionAddOns = [];
				}

				this.Form.transactionTypeData.transactionTypeAddOns.forEach(function (item) {

					if(item.type==0){

						if(bindAll){
							self.Form.items.forEach(function (itemData) {

								itemData.addOnsItems.push(JSON.parse(JSON.stringify(item)));

								(function (itemData) {
									itemData.netAmount = self.$refs['ref_dialogProduct'].fn_computeValues(itemData);
								}(itemData));

							});
						}

	          			self.Form.productDataModel.addOnsItems.push(JSON.parse(JSON.stringify(item)));
					}
					else if(item.type==1 && bindAll){
						let addOnsData = JSON.parse(JSON.stringify(item));
						addOnsData.transactionAddOnsId = self.guid();
						addOnsData.isDefault = true;
						self.Form.transactionAddOns.push(addOnsData);
					}
	          	});

			},

			fn_getNumberSeries: function(){
				var self = this;
				this.getData('NumberSeries', 'e04a5ba6-48a0-4f54-88ab-02fc102f9671', 
					{
						onSuccess: function(response){
							console.log(response);
							// let data = JSON.parse(response);
							self.Form.numberSeriesData = JSON.parse(response);
							self.fn_bindTransactionNumber();
							// self.Form = JSON.parse(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_bindTransactionNumber: function () {

				let date = new Date();
				let currentMonth = date.getMonth() + 1;
				let currentYear = date.getFullYear();

				let currentFY = currentMonth <= 3 ? (currentYear - 1) : currentYear;

				let currentTransactionNumberData = this.Form.numberSeriesData.transactionNumbers.filter(item=>{
					return item.fiscalYear == currentFY;
				})

				this.transactionNumberSnackbar = false;

				// let numberSeriesData = this.Form.transactionTypeData.numberSeries;

				this.Form.transactionData.prefix = currentTransactionNumberData[0].prefix;
				this.Form.transactionData.suffix = currentTransactionNumberData[0].suffix;

				//For reference use only as incrementing transaction number by numberSeries id in transaction number
				this.Form.transactionData.numberSeriesId = currentTransactionNumberData[0].numberSeriesId;

				// this.Form.transactionData.transactionNumberId = numberSeriesData.transactionNumberId;

				let filterObject = {};
				filterObject.numberSeriesId = currentTransactionNumberData[0].numberSeriesId;
				// filterObject.transactionNumberId = numberSeriesData.transactionNumberId;
				filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));

				let self = this;

				this.getFilterData('TransactionNumber', null, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);
							self.Form.transactionData.transactionNumber = Number(data.transactionNumber);
							self.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
							self.Form.transactionData.transactionNumberId = data.transactionNumberId;
				        }, 
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
				
			},

			fn_openDialogNumberSeries: function(){
				this.transactionNumberSnackbar = false;
				this.fn_openDialogWeb('web', 'NumberSeries', 'ref_dialogNumberSeries')
			},

			fn_checkTransactionNumber: function(callback){
				var self = this;
				let filterObject = {};
				filterObject.mergeTransactionNumber = this.Form.transactionData.mergeTransactionNumber;
				filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));
				filterObject.typeId = 40005;
				let transactionId = this.Form.transactionData.transactionId ? this.Form.transactionData.transactionId : null;
				this.getFilterData('CheckTransactionNumber', transactionId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							callback ? callback() : '';
				        }, 
				        onError: function(error){
				        	self.disabledBtn = false;
				          	console.log(error);
				          	self.showToast('Transaction number already exists');
				          	self.hideLoading();
				          	self.transactionNumberSnackbar = true;
				        }
					}
		        );
			},

			fn_editItem: function(item, index){
				// this.Form.productData = item;
				this.fn_addProduct('edit', index);
				this.Form.qty = item.qty;
				this.Form.averageRate = item.averageRate;
				this.fn_updateProduct(item.productId, item.productName, item.batches, true);
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		computed:{
			totalAmount: function(){
				let total = 0;
				for(let i=0; i<this.Form.transactionProducts.length; i++){
					if(this.Form.transactionProducts[i].averageRate){
						total += this.Form.transactionProducts[i].averageRate * this.Form.transactionProducts[i].qty;
					}
				}
				return total;
			}
		},
		mounted: function(){

			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'draft_transaction_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'draft_transaction_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			// !this.$root.CurrentBusiness.DataDrive ? this.fn_checkTransactionCount() : '';
			// if(!this.$root.CurrentBusiness.DataDrive){
			// 	this.fn_checkTransactionCount(()=>{
			// 		if(this.transactionCount>=3 || this.fn_differenceOfDays() > 7){
			// 			this.fn_openDialogDriveSetup();
			// 		}
			// 	})
			// }

			var formsArray = [];
			if(localStorage.getItem('stocktransfer')){
				formsArray = JSON.parse(localStorage.getItem('stocktransfer'));
			}

			formsArray.push(this.formId);
			localStorage.setItem('stocktransfer', JSON.stringify(formsArray));

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;

			this.fn_showWebView();

			if(localStorage.getItem('closeDialog')){
				this.fn_closeDialog();
				localStorage.removeItem('closeDialog');
			}
			else{
				dialogjs.fn_checkAndShowOpenDialogs(this);
			}

			this.unwatch = true;
			// this.Form.isNew ? this.Form.transactionData.transactionDate = new Date() : '';
			// this.Form.transactionData.transactionDate = new Date();
			if(new Date().getTime() < new Date(this.$root.CurrentBusiness.OpeningDate).getTime()){
				this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(this.$root.CurrentBusiness.OpeningDate);
			}
			else{
				this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat();	
			}

            setTimeout(function(){self.fn_setNewItem()},300);

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});
			

            if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){
				var self = this;
				this.unwatch = true;
				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.Form = JSON.parse(draft.formData);
					}
					else{
						localStorage.removeItem('newSelection');
					}

		            self.$route.query.tagId ? self.fn_checkDraftItems('Stock Transfer') : '';

				});
			}

			// if(this.$root.TransactionSettings.batchFields && this.$root.TransactionSettings.batchFields.length){
			// 	for(let i=0; i<this.$root.TransactionSettings.batchFields.length; i++){
			// 		let field = this.$root.TransactionSettings.batchFields[i]
			// 		if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
			// 			this.hasSeries = true;
			// 		}

			// 		if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'field4'){
			// 			this.hasOnlySeries = false;
			// 		}
			// 	}
			// }

			// if(!this.Form.selectedBatchType){
			// 	this.Form.selectedBatchType = !this.hasOnlySeries ? 1 : 2;
			// }

			// setTimeout(() => {
			// 	if(localStorage.getItem('batch_data')){
			// 		if(!this.Form.productBatches || !this.Form.productBatches.length){
			// 			this.Form.productBatches = [];
			// 		}
			// 		let bArray = JSON.parse(localStorage.getItem('batch_data'));
			// 		for(let i=0; i<bArray.length; i++){
			// 			bArray[i].productQty = null;
			// 			this.Form.batches.push(bArray[i]);
			// 			this.Form.productBatches.push(bArray[i]);
			// 			this.$forceUpdate();
			// 		}

			// 		localStorage.removeItem('batch_data');
			// 	}
			// }, 1000);

			// setTimeout(function(){self.fn_setNewItem()},300);

			this.fn_setDraftData('Transaction', 'Stock Transfer');
			this.seriesFields = [];
			if(this.$root.TransactionSettings.enableBatch && this.$root.TransactionSettings.batchFields && this.$root.TransactionSettings.batchFields.length){
				for(let i=0; i<this.$root.TransactionSettings.batchFields.length; i++){
					let field = this.$root.TransactionSettings.batchFields[i]
					if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
						this.hasSeries = true;
						this.seriesFields.push(field);
					}

					if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'field4'){
						this.hasOnlySeries = false;
					}
				}

				if(!this.Form.selectedBatchType){
					this.Form.selectedBatchType = !this.hasOnlySeries ? 1 : 2;
				}
			}

		},
	    beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					if(this.transactionCount >= 10 && this.$refs['ref_dialogDriveAlert'].backupAlertSheet){
						this.fn_draftAction(true);
						next(true);
					}
					else{
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						this.backButtonPress = false;
						next(false);
					}
				}
				else{
					localStorage.removeItem("SetDataDrive");
					next(true);
				}
			}
			else{
                if(this.fn_showDialogDiscard()){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					this.fn_clearData('stocktransfer', function(){
						localStorage.removeItem("SetDataDrive");
						next();
					})
				}
				// next(true);
			}
	    },
	    beforeRouteEnter (to, from, next) {
		  	next(vm => {

		  		let itemId = null;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
					itemId = from.params.tagId;
					vm.fn_getData(itemId);
				}
				else{
					vm.fn_getNumberSeries();
				}

				//edit from list view
		  		// else if(from.name=='stockJournalItems' && (to.params && to.params.tagId)){
		  		// 	itemId = to.params.tagId;
		  		// }

		  		//checking if draft exist
		  		// vm.fn_isDraft(function(isDraft){
		  		// 	if(itemId && !isDraft){
		  		// 		vm.fn_getData('TransactionProducts', itemId);
		  		// 	}

		  		// 	let setTFT = !itemId && !isDraft;

		  		// 	vm.fn_getTransactionTypeList(setTFT);
		  		// })

		  	})
		}
	    // computed:{
	    // 	totalAmount: function(){
	    // 		let rate = this.Form.rate ? this.Form.rate : 0;
	    // 		return this.roundUpto2Decimals(rate * this.Form.qty);
	    // 	}
	    // }
	}

</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/stock_transfer/form.vue